import { UIChartLine } from '../line/ui-chart-line';
import { Component } from '../../../shared-components/decorators/component.decorator';
import styles from './ui-chart-area.css';

/**
 * @class
 * @memberof ChartsComponents
 * @element ui-chart-area
 * @augments {UIChartLine}
 * @alias UIChartArea
 * @classdesc Represents a class for <code>ui-chart-area</code> element.
 * Draws area type chart.
 * @slot {@type "ui-series"}
 * @example
 * <ui-chart-area preset="interactive">
 *   <ui-series data="[10, 25, 50, 33, 43, 98]"></ui-series>
 * </ui-chart-area>
 */
@Component({ tag: 'ui-chart-area', styles })
export class UIChartArea extends UIChartLine {
    override get type(): string {
        return 'area';
    }

    /**
     * @inheritDoc
     */
    override renderChart(): void {
        this.draw({
            xAxis: {
                tickmarkPlacement: 'on',
            },
            tooltip: {
                enabled: true,
            },
            plotOptions: {
                series: {
                    pointPlacement: 'on',
                    enableMouseTracking: true,
                    dataLabels: {
                        enabled: false,
                    },
                    marker: {
                        enabled: true,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true,
                            },
                        },
                    },
                    legendSymbol: 'rectangle',
                },
            },
        });
    }
}
